module.exports = __webpack_public_path__ + "img/step-1.30dbcd3f.png";